var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphLeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 30 30",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#5990e4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 9.75C15.7501 9.55109 15.6711 9.36032 15.5304 9.21967C15.3898 9.07902 15.199 9 15.0001 9C14.8012 9 14.6104 9.07902 14.4698 9.21967C14.3291 9.36032 14.2501 9.55109 14.2501 9.75L14.2501 10.5C14.2501 10.6989 14.3291 10.8897 14.4698 11.0303C14.6104 11.171 14.8012 11.25 15.0001 11.25C15.199 11.25 15.3898 11.171 15.5304 11.0303C15.6711 10.8897 15.7501 10.6989 15.7501 10.5L15.7501 9.75Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2427 11.8179C19.3793 11.6765 19.4549 11.487 19.4532 11.2904C19.4515 11.0937 19.3726 10.9056 19.2336 10.7665C19.0945 10.6275 18.9064 10.5486 18.7097 10.5469C18.5131 10.5452 18.3236 10.6208 18.1822 10.7574L17.6519 11.2877C17.5153 11.4291 17.4397 11.6186 17.4414 11.8152C17.4431 12.0119 17.522 12.2 17.6611 12.339C17.8001 12.4781 17.9882 12.557 18.1849 12.5587C18.3815 12.5604 18.571 12.4848 18.7124 12.3482L19.2427 11.8179Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15C21 15.1989 20.921 15.3897 20.7803 15.5303C20.6397 15.671 20.4489 15.75 20.25 15.75L19.5 15.75C19.3011 15.75 19.1103 15.671 18.9697 15.5303C18.829 15.3897 18.75 15.1989 18.75 15C18.75 14.8011 18.829 14.6103 18.9697 14.4697C19.1103 14.329 19.3011 14.25 19.5 14.25L20.25 14.25C20.4489 14.25 20.6397 14.329 20.7803 14.4697C20.921 14.6103 21 14.8011 21 15Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2877 12.3482C11.3568 12.4198 11.4396 12.4769 11.5311 12.5162C11.6226 12.5555 11.721 12.5762 11.8206 12.5771C11.9202 12.578 12.0189 12.559 12.1111 12.5213C12.2033 12.4836 12.287 12.4279 12.3575 12.3575C12.4279 12.287 12.4836 12.2033 12.5213 12.1111C12.559 12.0189 12.578 11.9202 12.5771 11.8206C12.5762 11.721 12.5555 11.6226 12.5162 11.5311C12.4769 11.4396 12.4198 11.3568 12.3482 11.2877L11.8179 10.7574C11.6765 10.6208 11.487 10.5452 11.2904 10.5469C11.0937 10.5486 10.9056 10.6275 10.7665 10.7665C10.6275 10.9056 10.5486 11.0937 10.5469 11.2904C10.5452 11.487 10.6208 11.6765 10.7574 11.8179L11.2877 12.3482Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15C11.25 15.1989 11.171 15.3897 11.0303 15.5303C10.8897 15.671 10.6989 15.75 10.5 15.75L9.75 15.75C9.55109 15.75 9.36032 15.671 9.21967 15.5303C9.07902 15.3897 9 15.1989 9 15C9 14.8011 9.07902 14.6103 9.21967 14.4697C9.36032 14.329 9.55109 14.25 9.75 14.25L10.5 14.25C10.6989 14.25 10.8897 14.329 11.0303 14.4697C11.171 14.6103 11.25 14.8011 11.25 15Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.5L13.5 18.75L16.5 18.75L16.5 19.5C16.5 19.8978 16.342 20.2794 16.0607 20.5607C15.7794 20.842 15.3978 21 15 21C14.6022 21 14.2206 20.842 13.9393 20.5607C13.658 20.2794 13.5 19.8978 13.5 19.5Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.9998C16.5112 17.7448 16.656 17.5153 16.8577 17.3556C17.3473 16.9695 17.7043 16.4405 17.8794 15.8422C18.0544 15.2438 18.0386 14.6058 17.8343 14.0168C17.63 13.4278 17.2473 12.9171 16.7393 12.5557C16.2314 12.1942 15.6234 12 15 12C14.3766 12 13.7686 12.1942 13.2607 12.5557C12.7527 12.9171 12.37 13.4278 12.1657 14.0168C11.9614 14.6058 11.9456 15.2438 12.1206 15.8422C12.2957 16.4405 12.6527 16.9695 13.1422 17.3556C13.3447 17.5153 13.4887 17.7448 13.4992 17.9998L16.5007 17.9998L16.5 17.9998Z",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLeadIcon);
export default __webpack_public_path__ + "static/media/graphLeadIcon.dc00ee7cd756f30ea02d69530c81729e.svg";
export { ForwardRef as ReactComponent };